// src/hooks/useAlert.js
import { useContext } from 'react';
import { AlertContext } from '../context/alert/alertContext'; // Ajuste o caminho se necessário

const useAlert = () => {
    const context = useContext(AlertContext);
    if (context === undefined) {
        throw new Error('useAlert deve ser usado dentro de um AlertProvider');
    }
    return context;
};

export default useAlert;